/* TrustSignalCard.tsx generated by @compiled/babel-plugin v0.26.0 */
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["cardStyles"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _18 = "._1p1dangw{text-transform:uppercase}";
const _17 = "._k48p9y44{font-weight:800}";
const _16 = "._1dyznl7k{letter-spacing:.3px}";
const _15 = "._19pk1eps{margin-top:var(--ds-space-100)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives/responsive';
import { BodyLarge, H2 } from '@atlassian/mpac-primitives';
import React from 'react';
const _14 = "._rfx315o9:before{border-radius:0 var(--ds-border-radius,4px) var(--ds-border-radius,4px) 0}";
const _13 = "._1rusdjbo:before{background-color:var(--_1snsa0d)}";
const _12 = "._kfgtckbl:before{height:3pc}";
const _11 = "._1mp41y44:before{width:4px}";
const _10 = "._qnecidpf:before{left:0}";
const _9 = "._1cs8stnw:before{position:absolute}";
const _8 = "._1kt9b3bt:before{content:\"\"}";
const _7 = "@media (min-width:110rem){._1jg41gwv{max-width:360px}}";
const _6 = "._1ul9ncxg{min-width:264px}";
const _5 = "._2rko1d67{border-radius:var(--ds-border-radius,9pt)}";
const _4 = "._1yt4hiv4{padding:var(--ds-space-400)}";
const _3 = "._19it10s1{border:var(--_1y56ji6)}";
const _2 = "._bfhk1y1v{background-color:var(--_ldqei4)}";
const _ = "._kqswh2mm{position:relative}";
const Card = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  const {
      cardStyles
    } = __cmplp,
    __cmpldp = _objectWithoutProperties(__cmplp, _excluded2);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14]), /*#__PURE__*/React.createElement(C, _extends({}, __cmpldp, {
    style: _objectSpread(_objectSpread({}, __cmpls), {}, {
      "--_ldqei4": ix(__cmplp.cardStyles.backgroundColor),
      "--_1y56ji6": ix(__cmplp.cardStyles.border),
      "--_1snsa0d": ix(__cmplp.cardStyles.slabColor)
    }),
    ref: __cmplr,
    className: ax(["_kqswh2mm _bfhk1y1v _19it10s1 _1yt4hiv4 _2rko1d67 _1ul9ncxg _1jg41gwv _1kt9b3bt _1cs8stnw _qnecidpf _1mp41y44 _kfgtckbl _1rusdjbo _rfx315o9", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Card.displayName = 'Card';
}
const Label = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodyLarge,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded3);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_15, _16]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_19pk1eps _1dyznl7k", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}
const Heading = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = H2,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded4);
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_17, _18]), /*#__PURE__*/React.createElement(C, _extends({}, __cmplp, {
    style: __cmpls,
    ref: __cmplr,
    className: ax(["_k48p9y44 _1p1dangw", __cmplp.className])
  })));
});
if (process.env.NODE_ENV !== 'production') {
  Heading.displayName = 'Heading';
}
export const TrustSignalCard = _ref4 => {
  let {
    stats,
    label,
    cardStyles,
    statsStyles
  } = _ref4;
  return /*#__PURE__*/React.createElement(Card, {
    cardStyles: cardStyles
  }, /*#__PURE__*/React.createElement(Heading, {
    "aria-level": 3,
    style: statsStyles
  }, stats), /*#__PURE__*/React.createElement(Label, null, label));
};